<template>
  <div class="signin-wrapper2">
    <v-dialog v-model="vError" persistent max-width="700">
      <v-card>
        <v-card-title class="text-h5"> Error </v-card-title>
        <v-card-text>There was an error with your transaction:</v-card-text>
        <v-card-text
          ><code>{{ vMessage }}</code></v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="vError = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="register-modal-left">
      <img
        src="../img/eflexLogo.png"
        class="registration-icon"
        alt="eflex icon"
      />
      <p class="registration-description">
        A few clicks away from starting to buy and sell energy
      </p>
      <p></p>
    </div>
    <div class="register-modal-right">
      <form name="form" @submit.prevent="handleRegister" v-if="!showCode">
        <div v-if="!successful">
          <h4 class="registration-header">Register</h4>
          <div class="registration-subheader">
            Already have an account?
            <a class="registration-link" href="/login">Login</a>
          </div>
          <div class="form-group">
            <div class="form-flex">
              <div class="column2">
                <label for="companyName"
                  >Company Name <b><font color="#a41517">*</font></b></label
                >
                <input
                  v-model="user.companyName"
                  type="text"
                  name="companyName"
                  placeholder="Enter your company name."
                  class="bottom-margin2"
                  id="companyName"
                />
                <div
                  v-if="errors.has('companyName')"
                  class="alert alert-danger"
                  role="alert"
                >
                  Company Name is required!
                </div>
              </div>
              <div class="column2">
                <label for="companyType"
                  >Company Type <b><font color="#a41517">*</font></b></label
                >
                <select
                  v-model="user.role"
                  name="companyType"
                  class="bottom-margin2"
                  id="companyType"
                >
                  <option value="companyType" selected="true" disabled>
                    Choose your company type
                  </option>
                  <option value="tso">TSO</option>
                  <option value="dso">DSO</option>
                  <option value="fsp">FSP</option>
                </select>
                <div
                  v-if="errors.has('companyType')"
                  class="alert alert-danger"
                  role="alert"
                >
                  <font color="#a41517">Company Type is required!</font>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-flex">
              <div class="column2">
                <label for="email"
                  >Email <b><font color="#a41517">*</font></b>
                  <v-progress-circular
                    v-if="emailLoading"
                    :width="2"
                    :size="17"
                    color="#59c26b"
                    indeterminate
                    class="loading-spinner"
                  ></v-progress-circular
                  ><span v-if="emailError" class="email-span"
                    >Email already in use</span
                  ><span v-if="confirmed" class="email-span-green"
                    >Email is available!</span
                  ></label
                >
                <input
                  v-model="user.email"
                  v-validate="'required|email|max:50'"
                  type="email"
                  class="bottom-margin2"
                  name="email"
                  placeholder="Enter your email."
                  @blur="handleValidateEmail"
                />
                <div
                  v-if="errors.has('email')"
                  class="alert alert-danger"
                  role="alert"
                >
                  <font color="#a41517">Email is required!</font>
                </div>
                <div
                  v-if="submitted && errors.has('email')"
                  class="alert-danger"
                >
                  {{ errors.first("email") }}
                </div>
              </div>
              <div class="column2">
                <label for="password"
                  >Password <b><font color="#a41517">*</font></b></label
                >
                <input
                  v-model="user.password"
                  v-validate="'required|min:8|max:40'"
                  type="password"
                  class="bottom-margin2"
                  name="password"
                  placeholder="Enter your password, at least 8 characters."
                />
                <div
                  v-if="errors.has('password')"
                  class="alert alert-danger"
                  role="alert"
                >
                  <font color="#a41517">Password is required!</font>
                </div>
                <div
                  v-if="submitted && errors.has('password')"
                  class="alert-danger"
                >
                  {{ errors.first("password") }}
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <input
              hidden
              v-model="user.companyCode"
              value="companyCode"
              type="text"
              name="companyCode"
              class="bottom-margin2"
            />
          </div>
          <div class="form-group">
            <div class="form-flex">
              <div class="column2">
                <label for="companyAddress"
                  >Street Name<b><font color="#a41517">*</font></b></label
                >
                <input
                  v-model="user.companyAddress"
                  type="text"
                  name="address"
                  placeholder="Enter your street name."
                  class="bottom-margin2"
                />
                <div
                  v-if="errors.has('companyAddress')"
                  class="alert alert-danger"
                  role="alert"
                >
                  Street Name is required!
                </div>
              </div>
              <div class="column2">
                <label for="buildingNumber"
                  >Number <b><font color="#a41517">*</font></b></label
                >
                <input
                  v-model="user.buildingNumber"
                  type="text"
                  name="buildingNumber"
                  placeholder="Enter your building number."
                  class="bottom-margin2"
                />
                <div
                  v-if="errors.has('buildingNumber')"
                  class="alert alert-danger"
                  role="alert"
                >
                  Street Name is required!
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-flex">
              <div class="column2">
                <label for="city"
                  >City <b><font color="#a41517">*</font></b></label
                >
                <input
                  v-model="user.city"
                  type="text"
                  name="city"
                  placeholder="Enter your city name."
                  class="bottom-margin2"
                  id="city"
                />
                <div
                  v-if="errors.has('city')"
                  class="alert alert-danger"
                  role="alert"
                >
                  City Name is required!
                </div>
              </div>
              <div class="column2">
                <label for="postalCode"
                  >Postal Code <b><font color="#a41517">*</font></b></label
                >
                <input
                  v-model="user.postcode"
                  type="text"
                  name="postalCode"
                  placeholder="Enter your postal code."
                  class="bottom-margin2"
                />
                <div
                  v-if="errors.has('postcode')"
                  class="alert alert-danger"
                  role="alert"
                >
                  Postcode is required!
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-flex">
              <div class="column2">
                <label for="phoneNumber"
                  >Phone Number <b><font color="#a41517">*</font></b></label
                >
                <input
                  v-model="user.phoneNumber"
                  type="text"
                  name="phoneNumber"
                  placeholder="Enter your phone number."
                  class="bottom-margin2"
                />
                <div
                  v-if="errors.has('phoneNumber')"
                  class="alert alert-danger"
                  role="alert"
                >
                  Phone Number is required!
                </div>
              </div>
              <div class="column2">
                <label for="country"
                  >Country <b><font color="#a41517">*</font></b></label
                >
                <select
                  v-model="user.countryCode"
                  value="country"
                  class="bottom-margin2"
                >
                  <option value="country" selected="true" disabled>
                    Select a Country
                  </option>

                  <!-- <option
                    v-for="country in countries"
                    :value="country.countryCode"
                    v-bind:key="country.countryCode"
                  >
                    {{ country.countryName }}
                  </option> -->

                  <option value="AT" label="Austria">Austria</option>
                  <option value="BE" label="Belgium">Belgium</option>
                  <option value="BG" label="Bulgaria">Bulgaria</option>
                  <option value="HR" label="Croatia">Croatia</option>
                  <option value="FR" label="France">France</option>
                  <option value="DE" label="Germany">Germany</option>
                  <option value="GR" label="Greece">Greece</option>
                  <option value="HU" label="Hungary">Hungary</option>
                  <option value="IT" label="Italy">Italy</option>
                  <option value="LU" label="Luxembourg">Luxembourg</option>
                  <option value="NL" label="Netherlands">Netherlands</option>
                  <option value="PL" label="Poland">Poland</option>
                  <option value="PT" label="Portugal">Portugal</option>
                  <option value="RO" label="Romania">Romania</option>
                  <option value="ES" label="Spain">Spain</option>
                  <option value="SI" label="Slovenia">Slovenia</option>
                  <option value="SE" label="Sweden">Sweden</option>
                  <option value="CH" label="Switzerland">Switzerland</option>
                  <option value="TR" label="Turkey">Turkey</option>
                  <option value="UK" label="United Kingdom">United Kingdom</option>
                </select>
                <div
                  v-if="errors.has('country')"
                  class="alert alert-danger"
                  role="alert"
                >
                  Country is required!
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="required"
              ><b
                ><font color="#a41517">* required information.</font></b
              ></label
            >
          </div>
          <div class="signin-modal-bottom">
            <v-btn
              elevation="2"
              color="#59c26b"
              :loading="loading"
              :disabled="
                loading ||
                !user.companyName ||
                !user.role ||
                !user.email ||
                !user.password ||
                user.password.length < 8 ||
                !user.countryCode ||
                !user.buildingNumber ||
                !user.city ||
                !user.postcode ||
                !user.companyAddress || 
                !user.phoneNumber
              "
              class="transfer-button"
              v-on:click="handleRegister"
            >
              Submit</v-btn
            >
          </div>
        </div>
        <div class="form-group">
          <div
            v-if="message"
            class="alert"
            :class="successful ? 'alert-success' : 'alert-danger'"
          >
            {{ message }}
          </div>
        </div>
      </form>
      <div v-if="showCode">
        <div class="code-header">
          Please enter your 5 digit verification code:
        </div>
        <CodeInput
          :loading="false"
          class="input"
          v-on:complete="onComplete"
          :fields="5"
        />
        <div class="signin-modal-bottom">
          <v-btn
            elevation="2"
            color="#59c26b"
            :loading="loading"
            :disabled="loading"
            class="transfer-button"
            v-on:click="handleToken"
          >
            Submit</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import User from "../models/user";
import CountryDataService from "../services/CountryDataService";
import CodeInput from "vue-verification-code-input";
import axios from "axios";

export default {
  name: "Register",
  components: {
    CodeInput,
  },
  data() {
    return {
      showCode: false,
      loading: false,
      vError: false,
      vMessage: '',
      emailLoading: false,
      emailError: false,
      confirmed: false,
      rules: {
        required: (value) => !!value || "Required",
      },
      code: "",
      user: new User("", "", "", "", "", "", "", "", "", "", "", ""),
      submitted: false,
      successful: false,
      message: "",

      countries: [],
    };
  },

  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },

  mounted() {
    this.retrieveCountries();
  },

  methods: {
    async handleValidateEmail() {
      this.emailLoading = true;
      var re = /\S+@\S+\.\S+/;
      let valid = re.test(this.user.email);

      console.log("HERE... user email: " + this.user.email);

      if (valid) {
        axios
          .post("https://eflex-dev.azurewebsites.net/api/auth/check-email", {
            email: this.user.email
          })
          .then(
            (response) => {
              this.emailLoading = false;
              this.emailError = false;
              this.confirmed = true;
            },
            (error) => {
              this.emailLoading = false;
              this.confirmed = false;
              this.emailError = true;
            }
          );
      }
    },
    onComplete(code) {
      this.code = code;
    },
    retrieveCountries() {
      CountryDataService.getAll()
        .then((response) => {
          this.countries = response.data;
          console.log("HERE... load countries sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load countries error: " + e);
        });
    },

    // currentRole() {
    //   let role = this.$store.state.auth.user.role.match(/[^_]+$/)[0];
    //   switch (role) {
    //     case "ADMIN":
    //       return "Admin";
    //     case "TSO":
    //       return "TSO";
    //     case "DSO":
    //       return "DSO";
    //     case "FSP":
    //       return "FSP";
    //     default:
    //       return "";
    //   }
    // },

    handleToken() {
      this.submitted = true;
      this.loading = true;
      this.$validator.validate().then((isValid) => {
        if (isValid) {
          this.$store
            .dispatch("auth/handleToken", { code: this.code, user: this.user })
            .then(
              (data) => {
                console.log("HERERERERE", this.$store.state);
                this.successful = true;
                this.loading = false;
                switch (this.$store.state.auth.user.roles[0].name) {
                  case "ROLE_ADMIN":
                    this.$router.push("/dashboardAdmin");

                    break;
                  // case "ROLE_MOD":
                  //   this.$router.push("/dashboardMod");

                  //   break;

                  case "ROLE_TSO":
                    this.$router.push("/dashboardTSO");

                    break;
                  case "ROLE_DSO":
                    this.$router.push("/dashboardDSO");

                    break;
                  case "ROLE_FSP":
                    this.$router.push("/dashboardFSP");

                    break;
                  default:
                    this.$router.push("/dashboardDSO");
                }
              },
              (error) => {
                this.loading = false;
                console.log("ERRRRor", error);
                this.message =
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  error.message ||
                  error.toString();
                this.successful = false;
              }
            );
        }
      });
    },

     async handleRegister() {
      this.loading = true;
      console.log("handleRegister: ", this.user);
      await this.Apps.register();
      this.user.companyCode = "companyCode";
      this.message = "";
      this.submitted = true;
      this.$validator.validate().then((isValid) => {
        if (isValid) {
          this.$store.dispatch("auth/register", this.user).then(
            (data) => {
              console.log("Email: ", this.user.email);
              this.message = data.message;
              console.log("Message: ", data);
              this.successful = true;
              this.showCode = true;
              this.loading = false;
              console.log("Wmail", this.$store.state);
            },
            (error) => {
              this.loading = false;
              this.message = "Registration error. Please try again";
              this.successful = false;
              this.vError = true;
              this.loading = false;
              this.vMessage = error
            }
          );
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.signin-wrapper2 {
  width: 100%;
  min-height: 100vh;
  background: $green-background;
  margin-top: -100px;
  display: flex;
}

.register-modal {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 1px 4px 0 hsla(0, 0%, 0%, 0.2);
  display: flex;
}

.register-modal-left {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #253858;
  padding: 20px;
  width: 35%;
  overflow-x: hidden;
  background-image: url(../img/regImage.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.registration-icon {
  width: 150px;
  margin-bottom: 20px;
}

.registration-description {
  align-self: flex-start;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  width: 70%;
  margin-top: 50px;
}

.register-modal-left h4 {
  margin: 0 0 40px 0;
}

.registration-city {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: contain;
  opacity: 0.4;
}

.already-wrapper {
  margin-left: 10px;
}

.register-modal-right {
  padding: 100px 40px 40px 40px;
  width: 65%;
  background-color: #f8fcff;
}

.register-modal-right label {
  display: block;
  font-size: 0.9em;
  margin: 0 0 3px 5px;
  color: #979797;
}

.register-modal-right input,
.register-modal-right select {
  width: 100%;
  padding: 12px 10px !important;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #fff;
}

.register-modal-right input:focus,
.register-modal-right select:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.register-modal-right a {
  margin-top: 5px;
  margin-left: 5px;
  font-size: 0.75em;
  display: inline-block;
}

.register-modal-left .already-wrapper {
  font-size: 0.85em;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.register-modal .bottom-margin {
  margin-bottom: 10px;
}

.bottom-margin2 {
  margin-bottom: 20px;
}

.column2 {
  width: 48%;
}

.VueCarousel-slide > div {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 6px;
}

.registration-header {
  font-size: 24px;
  margin-bottom: 20px;
}

.registration-subheader {
  font-size: 18px;
  margin-bottom: 20px;
}

.registration-link {
  font-size: 18px !important;
  color: #59c26b !important;
  text-decoration: underline;
  font-weight: 700;
}

.register-modal-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  padding: 0 10px;
}

.cancel-button {
  width: 100%;
  color: $black !important;
  background: $dark-white !important;
  padding: 10px 15px;
  border-radius: 10px;
  border: none;
  background: $green;
  color: #fff;
}

.cancel-button:hover {
  background: hsl(210, 23%, 97%) !important;
}

.next-button {
  background: rgba(0, 0, 0, 0) !important;
  color: $black !important;
  border: 2px solid $green2 !important;
}

.next-button:hover {
  border: 2px solid hsl(144, 58%, 40%) !important;
}

.register-modal-button-wrapper a {
  border-radius: 10px;
  border: none;
  background: $green2;
  color: #fff;
}

.register-modal-button-wrapper a:hover {
  color: $black;
  text-decoration: none;
}

.register-modal-button-wrapper > button {
  width: 45%;
  padding: 10px 15px;
  border-radius: 10px;
  border: none;
  background: $green;
  color: #fff;
}

.register-modal-button-wrapper > button:hover {
  background: hsl(144, 58%, 40%);
}

.register-modal-button-wrapper button:focus {
  outline: none;
}

.checkbox-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 0 20px 5px;
  flex: 1;
}

.checkbox {
  width: auto !important;
}

.checkbox-label {
  margin: 0 0 0 10px !important;
}

.loader {
  background: rgba(0, 0, 0, 0.4);
  display: none;
  height: 100%;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.loader .helper {
  display: none;
  height: 40%;
  vertical-align: middle;
}
.loader > div {
  background-color: #fff;
  box-shadow: 10px 10px 60px #555;
  display: none;
  width: 20%;
  position: fixed;
  border-radius: 8px;
  padding: 15px 5%;
  margin-top: 19%;
  margin-left: -10%;
}

.link:hover {
  text-decoration: underline;
}

.signin-modal-bottom {
  width: 30%;
  margin-top: 20px;
}

.input {
  width: 100% !important;
}

.input input {
  margin: 10px 5px 20px 5px;
  border-radius: 3px !important;
  border: 1px solid #dbdbdb !important;
  font-family: "Roboto" !important;
}

.transfer-button {
  margin-bottom: 35px;
  margin-left: auto;
}

.transfer-button span {
  color: #fff;
  text-transform: none;
}

.loading-spinner {
  margin: 0 0 4px 10px;
}

.email-span {
  color: #a41517;
  margin-left: 10px;
}

.email-span-green {
  color: $green;
  margin-left: 10px;
}
</style>
